import RouteTemplate from "ember-route-template";

export default RouteTemplate(
  <template>
    <section class="proxyviews-methodology-page proxyviews-affiliate-disclosure-page">
      <div class="pd-hero">
        <span class="pd-hero__eyebrow">ProxyViews Integrity</span>
        <h1 class="pd-hero__title">
          <span>{{@model.title}}</span>
        </h1>
        <p class="pd-hero__subtitle">
          How we make money, and why it never touches our ratings, rankings, or reviews.
        </p>
      </div>

      <div class="pd-methodology-container">
        <div class="pd-methodology-grid">
          {{#each @model.sections as |section|}}
            <div class="pd-methodology-card">
              <h2 class="pd-methodology-card__heading">{{section.heading}}</h2>
              <p class="pd-methodology-card__body">{{section.body}}</p>
            </div>
          {{/each}}
        </div>
      </div>
    </section>
  </template>
);
